import { render } from "./PlanosViewProBasic.vue?vue&type=template&id=4ddb36e6&scoped=true"
import script from "./PlanosViewProBasic.vue?vue&type=script&lang=js"
export * from "./PlanosViewProBasic.vue?vue&type=script&lang=js"

import "./PlanosViewProBasic.vue?vue&type=style&index=0&id=4ddb36e6&scoped=true&lang=css"
import "./PlanosViewProBasic.vue?vue&type=style&index=1&id=4ddb36e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddb36e6"]])

export default __exports__